module.exports = __webpack_public_path__ + "img/barcode.2988595e.svg";